import React, { useEffect, useRef, useState } from 'react'
import { ActivityIndicator, Alert, TouchableOpacity, View } from 'react-native'
import { TopNavigationBar } from 'ui/common/top-navigation-bar'
import { colors } from 'infra/color'
import { observer } from 'mobx-react'
import { alert, alertError, useSafeAreaInsets } from 'infra/util'
import { Body1, ButtonText } from 'ui/common/text'
import { RowLayout } from 'ui/common/layout'
import { BottomButton, BottomButtonContainer } from 'ui/discovery/bottom-button'
import { CategorySelectStore } from 'store/category-select'
import { categoryStore } from 'store/category'
import { Place } from 'infra/type'
import { navigation } from 'navigation/global'
import { deletePlace, editPlace, requestDeletePlace } from 'api/writes'
import { useMe } from 'api/hooks'
import { placesStore } from 'store/places.ts'
import { placeMarkersCacheStore } from 'store/place-markers-cache-store.ts'
import { PlaceAddEdit } from 'ui/common/place-add-edit.tsx'

export const PlaceEditScreen = observer(({ route }: { route: any }) => {
  const safeAreaInsets = useSafeAreaInsets()
  const bottomStartAt = safeAreaInsets.bottom + 48
  const store = useRef(new CategorySelectStore()).current
  const place: Place = route.params.place
  const { data: meData } = useMe()
  const isAdmin = !!meData?.is_admin
  useEffect(() => {
    store.initData(categoryStore.raw)
    store.selectInitData(place.categories)
  }, [place, store])
  const [isLoading, setIsLoading] = useState(false)
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: colors.white,
        paddingTop: safeAreaInsets.top,
      }}
    >
      <TopNavigationBar title='장소 수정하기'>
        <RowLayout
          style={{ flex: 1, justifyContent: 'flex-end', marginRight: 16 }}
        >
          <TouchableOpacity
            style={{
              paddingHorizontal: 16,
              paddingVertical: 8,
            }}
            onPress={() => {
              Alert.alert(
                isAdmin ? '장소 삭제' : '장소 삭제 요청',
                isAdmin
                  ? '장소를 정말 삭제할까요? 되돌릴 수 없습니다!'
                  : '장소가 없어졌나요? 제보해주시면 매니저가 검토 후 장소를 삭제할게요!',
                [
                  {
                    text: '취소',
                  },
                  {
                    text: '확인',
                    onPress: () =>
                      (isAdmin ? deletePlace : requestDeletePlace)(place.id)
                        .then(() => {
                          placesStore.remove(place)
                          placeMarkersCacheStore.remove(place)
                          setTimeout(() => {
                            navigation.setRoot('HomeScreen')
                            if (!isAdmin) {
                              alert(
                                '장소 삭제 요청이 접수됐어요',
                                `감사드려요 🙏 매니저가 빠르게 확인하고 반영할게요!`,
                              )
                            }
                          })
                        })
                        .catch((e) => {
                          alertError(e)
                        }),
                  },
                ],
              )
            }}
          >
            <Body1 style={{ color: colors.gray.v600 }}>
              {isAdmin ? '삭제' : '장소가 없어졌어요'}
            </Body1>
          </TouchableOpacity>
        </RowLayout>
      </TopNavigationBar>
      <PlaceAddEdit place={place} store={store} bottomStartAt={bottomStartAt} />
      <BottomButtonContainer style={{ bottom: bottomStartAt }}>
        <BottomButton
          onPress={() => {
            setIsLoading(true)
            editPlace(place, store.selected)
              .then(() => {
                navigation.setRoot('HomeScreen', {
                  placeId: place.id,
                })
                alert(
                  '장소 정보가 수정되었어요 🥳',
                  `감사드려요 🙏 ${meData?.nickname}님 덕분에 빠르고 쉬운 장소 탐색에 더 가까워졌어요!`,
                )
              })
              .catch((e) => {
                alertError(e)
                setIsLoading(false)
              })
          }}
          disabled={!store.selected.length || isLoading}
          style={{ width: 120, alignItems: 'center' }}
        >
          {!isLoading ? (
            <ButtonText>수정하기</ButtonText>
          ) : (
            <ActivityIndicator color={colors.white} size='small' />
          )}
        </BottomButton>
      </BottomButtonContainer>
    </View>
  )
})
